import { Component, input } from '@angular/core';
import { EPlatform, EPlatformFeature } from '@enums/campaign.enum';
import { EEventType } from '@enums/event-tracking.enum';
import { IMediaContentApi } from '@interfaces/campaign-analytics-api.interface';
import { EmbeddedVideoPlayerComponent } from '@shared/components/embedded-video-player/embedded-video-player.component';
import { VideoPlayerComponent } from '@shared/components/video-player/video-player.component';
import { IVideoPlayedContext, IVideoPlayerConfiguration } from '@shared/components/video-player/video-player.interface';

@Component({
  imports: [VideoPlayerComponent, EmbeddedVideoPlayerComponent],
  selector: 'app-post-media-viewer',
  templateUrl: './post-media-viewer.component.html',
})
export class PostMediaViewerComponent {
  public readonly media = input.required<IMediaContentApi>();
  public readonly videoConfiguration = input.required<IVideoPlayerConfiguration>();
  public readonly seekTime = input.required<number>();
  public readonly platformFeature = input.required<EPlatformFeature>();

  public readonly EPlatformFeature = EPlatformFeature;
  public readonly EPlatform = EPlatform;

  // Always rendered inside the CTA analytics popup — see event-tracking-implementation-map.md #33.
  protected readonly videoPlayedContext: IVideoPlayedContext = {
    analyticsPopupActive: true,
    eventType: EEventType.campaignAnalyticsContentVideoPlayed,
  };
}
